const DIRECT = 'direct'
const UNIVERSITY = 'university'

export { DIRECT, UNIVERSITY }
